var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"action",attrs:{"aria-label":'Attachment',"title":'Attachment',"id":"atch-button"},on:{"click":_vm.navigate}},[_c('i',{staticClass:"material-icons"},[_vm._v("attach_file")]),_c('span',[_vm._v("Attachment")])])}
var staticRenderFns = []

export { render, staticRenderFns }